import { Column } from '~components/table-view-v3';

export const columns: Column[] = [
  {
    id: 'ref',
    header: 'Claim Item Ref',
    type: 'text',
  },
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'service_date',
    header: 'Service Date',
    type: 'date',
  },
  {
    id: 'reason',
    header: 'Reason',
    type: 'text',
  },
  {
    id: 'details',
    header: 'Details',
    type: 'text',
  },
];
